import { ChangeDetectionStrategy, Component } from '@angular/core';
import { dzPictogramCompleteSet } from '@blk/daisy/core/pictograms';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
	<div class="center-md">
	   <dz-pictogram *ngIf="params.icon" [name]="params.icon" size="medium"></dz-pictogram>
	   <p class="text-20-bold line-height-28" dcrHTMLKey="NO_FUNDS_TO_VIEW_TEXT">No funds matched your search</p>
	   <p class="text-16 line-height-24" dcrHTMLKey="VIEW_FUNDS_TEXT">Try searching with a different name or ticker/ISIN</p>
	 </div>
	`
})
export class NoRowsOverlayComponent implements INoRowsOverlayAngularComp {

	public params = { icon: '' };

	public agInit(params: any): void {
		if (params.icon && dzPictogramCompleteSet.find(pictogram => pictogram.name === params.icon)) {
			this.params.icon = params.icon;
		}
	}

	public refresh(): boolean {
		return false;
	}
}
